import { PaymentMethodsType } from "../../../../types/response/payments";
import { ApiResponse } from "../../../../types/shared";
import { Api } from "../Api";

export const Endpoints = Api.injectEndpoints({
  endpoints: (builder) => ({
    getAllPaymentMethods: builder.query<
      ApiResponse<PaymentMethodsType[]>,
      { id: number; enabled?: string | number }
    >({
      query: ({ id, enabled = "" }) =>
        `/club/${id}/payment_method?enable_only=${enabled}`,
      providesTags: ["paymentMethods"],
    }),
    createPaymentMethod: builder.mutation({
      query: ({ club_id, data }) => ({
        url: `/club/${club_id}/payment_method`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["paymentMethods"],
    }),
    editPaymentMethod: builder.mutation({
      query: ({ edits, id }) => ({
        url: `/club/payment_method/${id}`,
        method: "PATCH",
        body: edits,
      }),
      invalidatesTags: ["paymentMethods"],
    }),
    getAllPayments: builder.query({
      query: ({
        club_id,
        currentPage = "",
        limit = "",
        column = "",
        order = "",
        date = "",
        filter_type = "",
        from = "",
        to = "",
        payment_status = "",
        payment_method = "",
        booking_type = "",
      }) =>
        `/club/${club_id}/payments/all?page=${currentPage}&limit=${limit}&column=${column}&order=${order}&date=${date}&filter_type=${filter_type}&date_from=${from}&date_to=${to}&payment_status=${payment_status}&payment_method=${payment_method}&booking_type=${booking_type}&cashed_out=false`,
    }),
    getPaymentDetails: builder.query({
      query: ({ club_id, paymentId }) => `/${club_id}/payment/${paymentId}`,
    }),
    getAllPaymentsPackeges: builder.query({
      query: ({
        club_id,
        currentPage = "",
        limit = "",
        range = "",
        column = "",
        order = "",
      }) =>
        `/club/${club_id}/payments/cashed_outs?page=${currentPage}&limit=${limit}&range=${range}&column=${column}&order=${order}`,
    }),
    getPaymentPackegeById: builder.query({
      query: ({ club_id, paymentId }) =>
        `/club/${club_id}/cashout/${paymentId}/details?cashout_id=${paymentId}`,
    }),
    getGrossRevenue: builder.query({
      query: ({ club_id, from, to, filter_type }) =>
        `/club/${club_id}/gross?filter_type=${filter_type}&date_from=${from}&date_to=${to}`,
    }),
  }),
});

export const {
  useGetAllPaymentMethodsQuery,
  useCreatePaymentMethodMutation,
  useEditPaymentMethodMutation,
  useGetAllPaymentsQuery,
  useGetAllPaymentsPackegesQuery,
  useGetPaymentPackegeByIdQuery,
  useGetGrossRevenueQuery,
  useGetPaymentDetailsQuery,
} = Endpoints;
